module.exports = __webpack_public_path__ + "static/img/5.c4ced6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/5.png
// module id = xqni
// module chunks = 4